var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.busy,"variant":"info","size":"sm"},on:{"click":_vm.startDownload}},[_c('font-awesome-icon',{attrs:{"icon":"download"}}),(_vm.busy)?_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":""}}):_vm._e(),_vm._v(" Download rapport\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }